import { TranslationMessages } from 'react-admin';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import raId from 'ra-language-indonesian-new';
import orderDetail from './core/order-detail';

const id18n: TranslationMessages = {
    ...raId,
    ra: {
        ...raId.ra,
        action: {
            ...raId.ra.action,
            create: 'Tambah',
        },
        navigation: {
            ...raId.ra.navigation,
            no_filtered_results: 'Tidak ada hasil dari filter',
            clear_filters: 'Hapus filter',
        },
    },
    app: {
        action: {
            upload: 'Unggah',
            generate: 'Generate',
            fileUpload: {
                error: 'File CSV tidak dapat di proses',
                success: 'Data CSV selesai di unggah',
            },
        },
        menu: {
            master: {
                name: 'Master',
                submenu: {
                    goods: {
                        name: 'Barang',
                    },
                    store: {
                        name: 'Toko',
                    },
                    price: {
                        name: 'Harga',
                    },
                },
            },
            transaction: {
                name: 'Transaksi',
                submenu: {
                    target: {
                        name: 'Target',
                    },
                    schedule: {
                        name: 'Jadwal',
                    },
                    order: {
                        name: 'Pesanan',
                    },
                    orderDetail: {
                        name: 'Detail Pesanan',
                    },
                },
            },
            setting: {
                name: 'Pengaturan',
                submenu: {
                    setting: {
                        name: 'Parameter',
                    },
                    role: {
                        name: 'Peran',
                    },
                    user: {
                        name: 'Pengguna',
                    },
                },
            },
        },
    },
    resources: {
        goods: {
            name: 'Barang |||| Barang',
            action: {
                upload: 'Unggah Data Barang',
            },
            fields: {
                id: 'ID',
                code: 'Kode',
                name: 'Nama',
                purchasePrice: 'Harga Beli',
                sellingPrice: 'Harga Jual',
                stock: 'Stok',
                category: 'Kategori',
            },
        },
        price: {
            name: 'Harga Barang |||| Harga Barang',
            action: {
                upload: 'Unggah Data Harga',
            },
            fields: {
                id: 'ID',
                goods: 'Barang',
                goodsId: 'Barang',
                'goods.category': 'Kategori',
                minimumOrder: 'Minimal Order',
                price: 'Harga',
            },
        },
        settings: {
            name: 'Pengaturan |||| Pengaturan',
            fields: {
                name: 'Kode',
                val: 'Nilai',
            },
        },
        roles: {
            name: 'Peran |||| Peran',
            fields: {
                id: 'ID',
                code: 'Kode',
                name: 'Nama',
                isActive: 'Aktif',
            },
        },
        users: {
            name: 'Pengguna |||| Pengguna',
            fields: {
                id: 'ID',
                roles: 'Peran',
                role: 'Peran',
                roleId: 'Peran',
                userId: 'User Id',
                userid: 'User Id',
                password: 'Kata Sandi',
                name: 'Nama',
                phone: 'Telepon',
                email: 'Email',
                address: 'Alamat',
                isActive: 'Aktif',
            },
        },
        store: {
            name: 'Toko |||| Toko',
            action: {
                upload: 'Unggah Data Toko',
                generateQr: 'Generate QR',
            },
            fields: {
                id: 'ID',
                'user.name': 'Sales',
                userId: 'Sales',
                name: 'Nama',
                address: 'Alamat',
                latitude: 'Latitude',
                longitude: 'Longitude',
                phone: 'Telepon',
                creditLimit: 'Kredit',
                creditEffDtFrom: 'Awal Efektif Kredit',
                creditEffDtTo: 'Akhir Efektif Kredit',
                debt: 'Hutang',
                creditBalance: 'Saldo Kredit',
                visitDay: 'Hari',
                isGeneratedQr: 'QR',
            },
        },
        target: {
            name: 'Target |||| Target',
            fields: {
                storeId: 'Nama Toko',
                target: 'Target',
                effDateFrom: 'Tanggal Mulai',
                effDateTo: 'Tanggal Berakhir',
            },
        },
        schedule: {
            name: 'Jadwal |||| Jadwal',
            event: {
                generateSuccess: 'Jadwal berhasil dibuat',
                generateError: 'Gagal membuat jadwal',
            },
            fields: {
                userId: 'Sales',
                storeId: 'Nama Toko',
                visitDate: 'Tgl Kunjungan',
                attendanceMethod: 'Metode',
                distance: 'Jarak',
                checkinDate: 'Tgl Checkin',
                checkoutDate: 'Tgl Checkout',
            },
        },
        order: {
            name: 'Pesanan |||| Pesanan',
            fields: {
                createdAt: 'Tgl Dibuat',
                'user.name': 'Sales',
                createdBy: 'Sales',
                'schedule.store.id': 'Toko',
                invoiceNo: 'No Invoice',
                transactionStatus: 'Status',
                transactionType: 'Tipe',
                transactionAmount: 'Total',
                transactionCost: 'Biaya',
                transactionMargin: 'Margin',
                incentiveMargin: 'Ins (%)',
                incentiveAmount: 'Ins (Rp)',
            },
        },
        'order-detail': {
            name: 'Detail Pesanan |||| Detail Pesanan',
            fields: {
                'user.name': 'Sales',
                createdBy: 'Sales',
                'order.id': 'No Invoice',
                'order.invoiceNo': 'No Invoice',
                'order.transactionStatus': 'Status',
                description: 'Deskripsi',
                'order.createdAt': 'Tgl Dibuat',
                quantity: 'Jumlah',
                storeId: 'Toko',
                goodsId: 'Barang',
                purchasePrice: 'Harga Beli',
                sellingPrice: 'Harga Jual',
                amount: 'Total',
            },
        },
    },
};

const i18nProvider = polyglotI18nProvider(() => id18n, 'id');
export default i18nProvider;
